import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export const WeeklyExportsChart = ({
  weeklyExportsData
}: {
  weeklyExportsData: Record<string, number>;
}) => {
  const [t] = useTranslation('common');

  if (!weeklyExportsData) {
    return null;
  }

  const days = Object.keys(weeklyExportsData).map((day) => t(`${day.toLowerCase()}`));
  const values = Object.values(weeklyExportsData);

  const data = {
    labels: days,
    datasets: [
      {
        data: values,
        backgroundColor: values.map((_, idx) =>
          idx === values.length - 1 ? '#284986' : '#ccd7ea'
        ),
        borderRadius: 8,
        barThickness: 38
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }
    },
    scales: {
      y: { display: false, beginAtZero: true },
      x: { grid: { display: false } }
    }
  };

  return <Bar data={data} options={options} />;
};
